import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { IModelToValidate } from "./showroom-validation.component";

export class ShowroomValidationValidation {
    static init(modelToTest: IModelToValidate): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                name: "validationStockar",
                id: 1,
                applicable: () => true,
                trueExpression: (value) => value > 10,
                message: { text: "Antalet stockar får inte vara över 10 (error)" },
                model: () => null,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.warning,
                name: "validationPappersark",
                id: 2,
                applicable: () => true,
                trueExpression: (value) => value > 5,
                message: { text: "Antalet ark får vara över 5 men det är inte att rekommendera (varning)" },
                model: () => null,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                name: "validationStubbar",
                id: 3,
                applicable: () => true,
                trueExpression: (value) => value > 6,
                message: { text: "Antalet stubbar får inte vara över 6 (error)" },
                model: () => null,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.warning,
                name: "validationGrenar",
                id: 4,
                applicable: () => true,
                trueExpression: (value) => value > 3,
                message: { text: "Antalet grenar får vara över 3 men det är inte att rekommendera (varning)" },
                model: () => null,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.warning,
                name: "validationAlternativ1",
                id: 4,
                applicable: () => true,
                trueExpression: (value) => value.length < 3,
                message: { text: "Alternativ1 måste ha minst tre tecken" },
                model: () => modelToTest.alternativ1,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.warning,
                name: "validationAlternativ2",
                id: 4,
                applicable: () => true,
                trueExpression: (value) => value.length < 3,
                message: { text: "Alternativ2 måste ha minst tre tecken" },
                model: () => modelToTest.alternativ2,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                name: "validationAlternativ3",
                id: 4,
                applicable: () => true,
                trueExpression: (value) => value.length < 3,
                message: { text: "Alternativ3 måste ha minst tre tecken" },
                model: () => modelToTest.alternativ3,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                name: "validationAlternativ4",
                id: 4,
                applicable: () => true,
                trueExpression: (value) => value.length < 3,
                message: { text: "Alternativ4 måste ha minst tre tecken" },
                model: () => modelToTest.alternativ4,
                triggerOnLoad: true
            }
        ]);

        return context;
    }
}
